<template>
<div class="cart-widget">
  <a :href="themeData.base.pageUrls.cart">Korpa <span v-if="products.length">{{ products.length }}</span></a>
</div>
</template>

<script>
import CartWidget from './CartWidget.js';
export default CartWidget;
</script>
